import { RootState } from '../../../base';
import { FeatureFlags } from '../../../common';

export const organizationSelectors = {
    getCompanyInfo: (state: RootState) => state.organization.companyInfo,
    getCompanySettings: (state: RootState) =>
        state.organization.companySettings,
    getIsGetCompanyInfoLoading: (state: RootState) =>
        state.organization.uiState.isGetCompanyInfoLoading,
    getIsGetCompanySettingsLoading: (state: RootState) =>
        state.organization.uiState.isGetCompanySettingsLoading,
    getIsUpdateCompanySettingsLoading: (state: RootState) =>
        state.organization.uiState.isUpdateCompanySettingsLoading,
    isFlagOn: (state: RootState, flag: FeatureFlags) =>
        !!state.organization.companyInfo?.features?.includes(flag),
    getTags: (state: RootState) => state.organization.tags,
    isGetTagsLoading: (state: RootState) =>
        state.organization.uiState.isGetTagsLoading,
    isCreateTagLoading: (state: RootState) =>
        state.organization.uiState.isCreateTagLoading,
    isUpdateTagLoading: (state: RootState) =>
        state.organization.uiState.isUpdateTagLoading,
    getRejectApplicationReasons: (state: RootState) =>
        state.organization.companySettings?.rejectReasons || [],
    isCreateRejectReasonLoading: (state: RootState) =>
        state.organization.uiState.isCreateRejectReasonLoading,
    isUpdateRejectReasonLoading: (state: RootState) =>
        state.organization.uiState.isUpdateRejectReasonLoading,
    isDeleteRejectReasonLoading: (state: RootState) =>
        state.organization.uiState.isDeleteRejectReasonLoading,
};
